<template>
    <div class="msg-form" :class="(formDisabled || submiting) ? 'disabled' : ''" v-if="!loading">
      <div class="form-container">
        <div class="form-header">
          <span class="guide-message">{{ formConfig.FBootMessage }}</span>
        </div>
        <div class="form-content">
          <template v-for="(field, index) in formFields">
            <div
              :key="index"
              v-if="field.show"
              class="item-container"
              :class="
                field.fieldname === 'FMessage'
                  ? 'item-container--with-message'
                  : ''
              "
            >
              <div :id="field.fieldname" class="content-info">
                <span class="content-title">{{ field.name }}</span>
                <span v-if="field.required" class="content-tip">*</span>
                <span class="content-error" v-show="field.error">{{field.error}}</span>
              </div>
              <div class="input-row">
                <input
                  v-model="formData[field.fieldname]"
                  type="text"
                  class="content-input"
                  :class="{
                    'has-suffix': field.fieldname === 'FCaptcha',
                    'error': field.error
                  }"
                  :maxlength="field.max"
                />
                <div class="captcha-btn" @click="handleGetCaptcha" v-if="field.fieldname === 'FCaptcha'">
                  {{ isCountDown ? `${countdown}s重新发送` : '发送验证码' }}
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="form-commit">
          <button class="submit-btn" @click="submitForm">
            {{ $t("chat_feedback_submit_text") }}
          </button>
        </div>
      </div>
      <div class="popup-tip"></div>
      <div v-if="loading" class="form-loading">
        <div class="loading">
          <image
            src="@/static/icon/loading.svg"
            class="loading-pic"
            mode="aspectFit"
          />
        </div>
      </div>
    </div>
</template>

<script>
import globalWin from '@/utils/globalWin';
// import { CGI_URL } from '@/utils/config.js';
import {
  SEND_CAPTCHA,
  GET_CUSTOMER_MESSAGE_CONFIG,
  CREATE_CUSTOMER_MESSAGE,
} from '@/utils/api';
import DOMAIN from '@/imsdk/domain';
const domain = DOMAIN.getSDKDomain();
const regCheckMap = {
  FMobile: /^[1]([3-9])[0-9]{9}$/,
  FQQ: /^[1-9]\d{4,9}$/,
  FWx: /^[a-zA-Z]{1}[-_a-zA-Z0-9]{5,19}$/,
};
const INIT_COUNTDOWN = 60;

export default {
  name: 'form-msg',
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formDisabled: false,
      loading: true,
      formConfig: {},
      formFields: [],
      formData: {},
      submiting: false,
      countdown: INIT_COUNTDOWN,
    };
  },

  created() {
    this.fetchFormConfig();
  },

  computed: {
    isCountDown() {
      return this.countdown !== INIT_COUNTDOWN;
    },
  },

  methods: {
    // 获取验证码
    handleGetCaptcha() {
      if (this.isCountDown) return;
      const index = this.formFields.findIndex(item => item.fieldname === 'FMobile');
      if (this.formFields[index].show) {
        // 手机号为空
        if (!this.formData.FMobile.trim()) {
          this.$set(this.formFields[index], 'error', '不能为空');
          return;
        }
        // 手机号格式
        if (!regCheckMap.FMobile.test(this.formData.FMobile.trim())) {
          this.$set(this.formFields[index], 'error', '格式不正确');
          return;
        }
        // 清空错误
        this.$set(this.formFields[index], 'error', '');
      }
      const params = this.data.msgBody.formParams;
      this.$ajax.post(`${domain.consolecgi}${SEND_CAPTCHA}?kfuin=${params.kfuin}`, {
        FMobile: this.formData.FMobile.trim(),
      })
        .then((res) => {
          if (res.data.code === 1000) {
            this.countdown -= 1;
            this.timer = setInterval(() => {
              if (this.countdown > 1) {
                this.countdown -= 1;
              } else {
                this.countdown = INIT_COUNTDOWN;
                clearInterval(this.timer);
              }
            }, 1000);
            console.log(res);
          } else {
            this.$Toast({ text: res.data.msg || this.$t('chat_feedback_error_msg'), type: 'error' });
          }
        })
        .catch((e) => {
          console.log('e', e);
          this.$Toast({ text: e.msg || this.$t('chat_feedback_error_msg'), type: 'error' });
        });
    },
    /**
     * 获取表单配置信息
     */
    // mock 模式下可以放开注释模拟
    // fetchFormConfig() {
    //   this.loading = false;
    //   const data = {
    //     "FBootMessage":"客服无法及时接待您，请留下问题和联系方式，我们会尽快与您联系",
    //     "fields":[
    //         {
    //             "name":"姓名",
    //             "show":1,
    //             "type":"string",
    //             "required":1,
    //             "sort":2,
    //             "max":15,
    //             "fieldname":"FCustomerName",
    //             "class":""
    //         },
    //         {
    //             "name":"企业名称",
    //             "show":1,
    //             "type":"string",
    //             "required":1,
    //             "sort":2,
    //             "max":100,
    //             "fieldname":"FCompany",
    //             "class":""
    //         },
    //         {
    //             "name":"手机",
    //             "show":1,
    //             "type":"string",
    //             "required":1,
    //             "sort":3,
    //             "max":11,
    //             "fieldname":"FMobile",
    //             "class":""
    //         },
    //         {
    //             "name":"验证码",
    //             "show":1,
    //             "type":"string",
    //             "required":1,
    //             "sort":4,
    //             "max":100,
    //             "fieldname":"FCaptcha",
    //             "class":""
    //         },
    //         {
    //             "name":"QQ",
    //             "show":1,
    //             "type":"string",
    //             "required":1,
    //             "sort":4,
    //             "max":15,
    //             "fieldname":"FQQ",
    //             "class":""
    //         },
    //         {
    //             "name":"微信",
    //             "show":1,
    //             "type":"string",
    //             "required":1,
    //             "sort":5,
    //             "max":20,
    //             "fieldname":"FWx",
    //             "class":""
    //         },
    //         {
    //             "name":"留言",
    //             "show":1,
    //             "type":"string",
    //             "required":1,
    //             "sort":6,
    //             "max":100,
    //             "fieldname":"FMessage",
    //             "class":"item-message"
    //         }
    //     ],
    //     "type":"webim"
    //   }
    //   this.formConfig = data;
    //   this.formFields = this.formConfig.fields;
    //   // 排序fields
    //   const sort = function (a, b) {
    //     return a.sort < b.sort ? -1 : 1;
    //   };
    //   this.formFields.sort(sort);

    //   // 设置表单项
    //   this.formFields.forEach((field) => {
    //     this.$set(this.formData, field.fieldname, '');
    //   });
    //   globalWin.scrollToBottom && globalWin.scrollToBottom();
    // },
    fetchFormConfig() {
      const params = this.data.msgBody.formParams;
      // todo 待统一替换
      const url = `${domain.consolecgi}${GET_CUSTOMER_MESSAGE_CONFIG}?kfuin=${params.kfuin}&key=${params.key}`;
      this.$ajax.get(url, {
        params,
      })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 1000) {
            this.formConfig = {
              FBootMessage: '请勿重复提交留言',
              fields: [],
              type: 'webim',
            };
            this.formFields = [];
            this.formDisabled = true;
            return false;
          }

          this.formConfig = res.data.data;
          this.formFields = this.formConfig.fields;
          // 排序fields
          const sort = function (a, b) {
            return a.sort < b.sort ? -1 : 1;
          };
          this.formFields.sort(sort);

          // 设置表单项
          this.formFields.forEach((field) => {
            this.$set(this.formData, field.fieldname, '');
          });
          globalWin.scrollToBottom && globalWin.scrollToBottom();
        })
        .catch((error) => {
          throw error;
        });
    },

    /**
     * 提交表单
     */
    submitForm() {
      const params = this.data.msgBody.formParams;
      // 整理表单数据，去除前后空格
      const data = {
        type: 'wxplugin',
      };
      this.formFields.forEach((field) => {
        if (field.show) {
          const val = this.formData[field.fieldname].replace(/^\s+/, '').replace(/\s+$/, '');
          this.formData[field.fieldname] = val;
          data[field.fieldname] = val;
        }
      });

      // 验证表单
      if (!this.validateItem()) {
        return;
      }

      Object.assign(data, params);

      this.submiting = true;
      const url = `${domain.api}${CREATE_CUSTOMER_MESSAGE}?kfuin=${params.kfuin}`;
      this.$ajax.post(url, data)
        .then((res) => {
          this.submiting = false;
          if (res.data.code === 0) {
            this.$Toast('留言已提交，期待您的再次来访');
            this.formDisabled = true;
          } else {
            this.$Toast({ text: res.data.msg || this.$t('chat_feedback_error_msg'), type: 'error' });
          }
        });
    },

    /**
     * 验证表单
     */
    validateItem() {
      let status = true;

      this.formFields.forEach((field) => {
        const value = this.formData[field.fieldname];

        if (field && field.show) {
          // 先清空上次的错误
          this.$set(field, 'error', '');

          if (field.required && !value.length) {
            this.$set(field, 'error', '不能为空');
            status = false;
          }

          if (status && field.max && value.length > field.max) {
            this.$set(field, 'error', `不能超过个${field.max}字符`);
            status = false;
          }

          if (status && value.length && regCheckMap[field.fieldname]) {
            if (!regCheckMap[field.fieldname].test(value)) {
              this.$set(field, 'error', '格式不正确');
              status = false;
            }
          }
        }
      });

      return status;
    },
  },
};
</script>

<style lang="less" scoped>
.msg-form {
  min-width: 286px;
  max-width: 380px;
  &.disabled {
    pointer-events: none;

    .content-input {
        opacity: .38;
        background-color: #ebedf2;
    }
    .form-commit {
        opacity: .38;
    }
  }

  .form-container {
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    border-radius: 6px;
    box-shadow: 0 1px 5px 0 rgba(223, 223, 223, 1);
    background-color: #fff;
    transition: height 0.3s;
  }

  .form-header {
    margin-bottom: -11px;
    height: 56px;
    background: url("./assets/form-head.png") no-repeat top right;
    background-size: 100%;
  }

  .form-content {
    overflow: hidden;
    margin-top: 12px;
    padding: 0 20px;
  }

  .guide-message {
    width: calc(100% - 106px);
    display: inline-block;
    padding: 10px 0 0 20px;
    word-wrap: break-word;
    font-size: 13px;
    line-height: 18px;
    color: rgba(98, 98, 98, 1);
  }

  .item-container {
    float: left;
    margin: 12px 0 0 0;
    width: 47%;
    // height: 55px;

    &:nth-child(2n) {
      float: right;
    }

    &--with-message {
      width: 100%;
    }
  }

  .item-container .content-info {
    display: flex;
    align-items: center;
  }
  .item-container .input-row {
    display: flex;
    position: relative;
    .captcha-btn {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 4px;
      cursor: pointer;
      color: #4a70ff;
      font-size: 12px;
      transition: all .3s;
    }
  }

  .item-container .content-error {
    display: block;
    flex: 10;
    font-size: 12px;
    text-align: right;
    color: #f75559;
  }

  .content-title {
    font-size: 13px;
    color: #000;
  }

  .content-tip {
    flex: 1;
    display: inline-block;
    font-size: 12px;
    color: #f75559;
  }

  .content-input {
    display: inline-block;
    margin-top: 8px;
    padding: 6px 7px;
    width: 100%;
    height: 32px;
    font-size: 13px;
    line-height: 18px;
    background: #fff;
    border: 1px solid #dfdfdf;
    border-radius: 4px;
    box-sizing: border-box;

    &.error {
      border-color: rgba(247, 85, 89, 1);
    }
    &.has-suffix {
      padding-right: 80px;
    }
  }

  .form-commit {
    padding: 20px;
    .submit-btn {
      display: block;
      width: 100%;
      height: 40px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      background: rgba(74, 112, 255, 1);
      border: 0;
      border-radius: 3px;
      line-height: 40px;
      cursor: pointer;
      outline: 0;
      padding: 0px;

      &:hover {
        background: rgba(106, 138, 255, 1);
      }

      &:active {
        background: rgba(61, 92, 209, 1);
      }
    }
  }
}

.form-loading {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0.38;
  background-color: #fff;
  .loading {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 30px;
    height: 30px;
    margin: -15px 0 0 -15px;
  }
  .loading-pic {
    width: 30px;
    height: 30px;
    animation: rotate linear 1s infinite;
  }
}

.popup-tip {
  position: absolute;
  top: 50%;
  left: 50%;
  display: none;
  padding: 12px 20px;
  font-size: 14px;
  line-height: 22px;
  min-width: 112px;
  text-align: center;
  color: #fff;
  background: rgba(26, 29, 31, 1);
  border-radius: 8px;
  opacity: 0.66;
  transform: translate(-50%, -50%);

  &.show {
    display: block;
  }
}

@keyframes rotate {
  0%{
    transform: rotate(0deg);
  }
  100%{
    transform: rotate(360deg);
  }
}

.msg-unsupport{
  padding: 9px 13px;
  color: #999;
  text-align: center;
}
</style>
